import { createSlice } from '@reduxjs/toolkit';

export const globalSlice = createSlice({
    name: "global",
    initialState: {
        sorteos:[],
        sorteos_activos:[],
        captura:{
            sorteo:{nombre:''},
            tabla_registros:[],
            dashboard:{
                total_sorteo:0,
                total_numeros:0,
                total_liquidado:0
            }
        },
        sorteoInfo:{
            banqueo:0,
            total_vendido:0,
            total_banqueo:0,
            total_numeros:0,
            cantidad_maxima:0,
            numeros_ganadores:{
                id:0,
                id_sorteo:0,
                numero1:"",
                numero2:""
            },
            tabla_registros:[],
            tabla_registros2:[],
            info_sorteo:{
                nombre:'',
                estatus:0,
                multiple:0
            },
            grafica:{
                labels:[],
                datasets:[]
            }
        },
        profile:{
            nombre:'',
            direccion:'',
            ine:'',
            tel:'',
            email:''
        },
        liquidacion:[],
        talonera:{
            tabla1:[],
            tabla2:[],
            sorteo:{
                nombre:'sorteo',
                multiple:''
            },
            usuarios:[]
        }
    },
    reducers: {
        setSorteos: (state, action) => {
            state.sorteos = action.payload;
        },
        setActivos:(state,action)=>{
            state.sorteos_activos=action.payload;
        },
        setCaptura:(state,action)=>{
            state.captura=action.payload;
        },
        setSorteoInfo:(state,action)=>{
            state.sorteoInfo=action.payload;
        },
        setProfile:(state,action)=>{
            state.profile=action.payload;
        },
        setLiquidacion:(state,action)=>{
            state.liquidacion=action.payload;
        },
        setTalonera:(state,action)=>{
            var tbl=action.payload;
            state.talonera.tabla1=tbl.tabla1;
            state.talonera.tabla2=tbl.tabla2;
            state.talonera.sorteo=tbl.sorteo;
            state.talonera.usuarios=tbl.usuarios;
        }
    }
});

//Obtner el estado global
export const selectStateSorteos = (state) => state.global.sorteos;
export const selectSorteosActivos=(state)=>state.global.sorteos_activos;
export const selectCaptura=(state)=>state.global.captura;
export const selectSorteoInfo=(state)=>state.global.sorteoInfo;
export const selectProfile=(state)=>state.global.profile;
export const selectLiquidacion=(state)=>state.global.liquidacion;
export const selectTalonera=(state)=>state.global.talonera;


//Export otras acciones
export const { setSorteos,setActivos,setCaptura,setSorteoInfo,setProfile,setLiquidacion,setTalonera } = globalSlice.actions;
//Reducer
export default globalSlice.reducer;